export const navItems = [
  {
    id: 1,
    title: "Home",
    path: "/",
   
  },
  {
    id: 2,
    title: "Our Menu",
    
    submenu: [
      {
        title: 'Full Menu',
        path: '/boxed',
      },
      {
        title: 'Occasion Special',
        path: '/special',
      }
     
    ]
  },
  {
    id: 3,
    title: "Shop",
    path: "/products",
   
    submenu: [
      {
        title: 'Pizza',
        path: '/pizza',
      },
      {
        title: 'Salads',
        path: '/salads',
      },
      {
        title: 'Soups',
        path: '/soups',
      },
      {
        title: 'Desserts',
        path: '/desserts',
      },
      {
        title: 'Drinks',
        path: '/drinks',
      }  
    ]
  },
  {
    id: 4,
    title: "Gallery",
    path: "/gallery",
   
  },
  {
    id: 5,
    title: "Reservation",
  
    submenu: [
      {
        title: 'Open Table',
        path: "/reservation",
      },
    ] 
  },
  {
    id: 6,
    title: "Contact Us",
    path: "/contactUs",
  
  },
];

export const featured = [
  {
    cover: "../images/cat-2.jpg",
    name: "Salads",
   
  },
  {
    cover: "../images/cat-1.jpg",
    name: "Pizza",
   
  },
  {
    cover: "../images/cat-15.jpg",
    name: "Soups",
 
  },
  {
    cover: "../images/cat-14.jpg",
    name: "Desserts",
 
  },
  {
    cover: "../images/cat-20.jpg",
    name: "Drinks",
  
  },
]

export const scroll = [
  {
    cover: "../images/cat-6.jpg",
    name: "PROMO ACTION",
    para: "Lorem ispa hola yellow nahi kiyes  jereddf lerana yellow kariy oppo enklwn gshaus yelow nahi kariye oppo yeelo enkwn shjaus oppo enklwn gshjaus dskdskjs demate peroiu "
   
  },
  {
    cover: "../images/cat-5.jpg",
    name: "DAWAT-E-TA'AM",
    para: "Uoran ispa hola redlopw  yellow  vorrp enklwn gshjausnahi kariye oppo enklwn gshjaus yellow nahi kariye oppo enklwn gshjaus nahi kariye opponoent enklw jaus dskdskjsp "
   
  },
  {
    cover: "../images/cat-13.jpg",
    name: "BARKAT-AL-INSA",
    para: "Uoran ispa hola redlopw  yellow nahi norrakam enklwn gshjaus kariye oppo enklwn gshjaus yellow nahi kariye oppo enklwn gshjaus nahiye opponoent enklwn gshjaus skdskjs "
   
  }
]

export const ranDdishes = [
  {
    cover: "../images/cat-11.jpg",
    name: 'Fish Parmentier',
    price: '10.50',
    about: 'Cod, haddock, prawn and salmon in a creamy white wine and leek sauce, topped with mash potato and Gruyère cheese'
  },
  {
    cover: "../images/cat-3.jpg",
    name: 'Roast Duck Breast',
    price: '9.00',
    about: 'Roasted duck breast (served pink) with gratin potato and a griottine cherry sauce'

  },
  {
    cover: "../images/cat-6.jpg",
    name: 'Escalope de Veau',
    price: '7.50',
    about: 'Sautéed breaded veal escalope with watercress, lemon and veal jus.'

  },
  {
    cover: "../images/cat-4.jpg",
    name: 'Tuna Niçoise',
    price: '14.50',
    about: 'Chargrilled fresh tuna steak (served medium rare) on classic Niçoise salad with French beans, cherry tomatoes, black olives, peppers, new potatoes, egg, baby gem lettuce and red onion'

  },
  {
    cover: "../images/cat-1.jpg",
    name: 'Chicken and Walnut Salad',
    price: '11.50',
    about: 'Chargrilled chicken with avocado, baby gem lettuce, baby spinach, shallots, French beans, walnuts, croutons and a mustard dressing'

  },
  {
    cover: "../images/cat-6.jpg",
    name: 'Kebab Makkhan',
    price: '10.50',
    about: 'Pan roasted with gratin potato, braised Savoy cabbage, apples, thyme and calvados jus'

  },
  
]

export const chefR = [
  {
    id: "cr1",
    cover: "../images/cat-17.jpg",
    price: '12.00',
    name: 'Deconstruct Aneperiyya',
    about: 'Apples, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4'
  },
  {
    id: "cr2",
    cover: "../images/sal-3.jpg",
    price: '11.50',
    name: 'Summer Asian Slaw',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.5'
  },
  {
    id: "cr3",
    cover: "../images/cat-7.jpg",
    price: '8.50',
    name: 'Grilled Amayred Kebabs',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  }
]

export const saladsList = [
  {
    id: "sd1",
    cover: "../images/sal-6.jpg",
    price: '12.00',
    name: 'Easy Pasta Salad',
    about: 'Apples, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4'
  },
  {
    id: "sd2",
    cover: "../images/sal-5.png",
    price: '10.50',
    name: 'Rainbow Orzy Salad',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.5'
  },
  {
    id: "sd3",
    cover: "../images/sal-4.jpg",
    price: '8.50',
    name: 'Shredded Sprout Salad',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.3'
  },
  {
    id: "sd4",
    cover: "../images/sal-3.jpg",
    price: '10.00',
    name: 'Summer Asian Slaw',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.8'
  },
  {
    id: "sd5",
    cover: "../images/sal-2.jpg",
    price: '9.50',
    name: 'Cherry Couscous Salad',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.7'
  },
  {
    id: "sd6",
    cover: "../images/sal-1.jpg",
    price: '11.50',
    name: 'Bounded Paneer Salad',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  },
  {
    id: "sd7",
    cover: "../images/sal-7.jpg",
    price: '8.50',
    name: 'Salmon Avocado Salad',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.4'
  },
  {
    id: "sd8",
    cover: "../images/sal-8.jpg",
    price: '12.00',
    name: 'Grilled Romaine Salad',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  },
  {
    id: "sd9",
    cover: "../images/sal-9.jpg",
    price: '9.00',
    name: 'Mixed Cheese Salad',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  }
]


export const pizzaList = [
  {
    id: "pz1",
    cover: "../images/piz-6.jpg",
    price: '12.00',
    name: 'Gryloated Cheese Pizza',
    about: 'Apples, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.5'
  },
  {
    id: "pz2",
    cover: "../images/piz-5.jpg",
    price: '10.50',
    name: 'Mushroomfied Pizza',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.4'
  },
  {
    id: "pz3",
    cover: "../images/piz-4.jpg",
    price: '12.50',
    name: 'Mixed Melonated Pizza',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.6'
  },
  {
    id: "pz4",
    cover: "../images/piz-3.jpg",
    price: '14.00',
    name: 'Margherita Pizza',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.4'
  },
  {
    id: "pz5",
    cover: "../images/piz-2.jpg",
    price: '14.50',
    name: 'Hawaiian Pizza',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.5'
  },
  {
    id: "pz6",
    cover: "../images/piz-1.jpg",
    price: '13.50',
    name: 'Pepperoni Pizza',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.4'
  }
]


export const soupList = [
  {
    id: "sp1",
    cover: "../images/sop-6.jpg",
    price: '13.50',
    name: 'Manchow Soup',
    about: 'Apples, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4'
  },
  {
    id: "sp2",
    cover: "../images/sop-5.jpg",
    price: '11.50',
    name: 'Makai Shorba',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.3'
  },
  {
    id: "sp3",
    cover: "../images/sop-4.jpg",
    price: '11.00',
    name: 'Lentil Vegetable Soup',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.7'
  },
  {
    id: "sp4",
    cover: "../images/sop-3.jpg",
    price: '12.00',
    name: 'Mulligatawny Soup',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  },
  {
    id: "sp5",
    cover: "../images/sop-2.jpg",
    price: '14.00',
    name: 'Okrashonva Soup',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.5'
  },
  {
    id: "sp6",
    cover: "../images/sop-1.jpg",
    price: '11.50',
    name: 'Keranovich Soup',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.3'
  }
]

export const dessertList = [
  {
    id: "ds1",
    cover: "../images/des-6.jpg",
    price: '14.50',
    name: 'Pecan Apple cake',
    about: 'Apples, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.6'
  },
  {
    id: "ds2",
    cover: "../images/des-5.jpg",
    price: '15.50',
    name: 'Boston Tarted Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.7'
  },
  {
    id: "ds3",
    cover: "../images/des-4.jpg",
    price: '11.00',
    name: 'Banana Pudding',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.5'
  },
  {
    id: "ds4",
    cover: "../images/des-3.jpg",
    price: '14.00',
    name: 'Mampostial Heaven',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  },
  {
    id: "ds5",
    cover: "../images/des-2.jpg",
    price: '12.00',
    name: 'Ketaorough Sliced Teane',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.5'
  },
  {
    id: "ds6",
    cover: "../images/des-1.jpg",
    price: '11.50',
    name: 'Obkarashskha Seetpellow',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.7'
  }
]


export const drinkList = [
  {
    id: "dk1",
    cover: "../images/drk-6.jpg",
    price: '14.50',
    name: 'Peruion Mezcalour',
    about: 'Apples, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4'
  },
  {
    id: "dk2",
    cover: "../images/drk-5.jpg",
    price: '15.50',
    name: 'Renkopa Mixed',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.7'
  },
  {
    id: "dk3",
    cover: "../images/drk-4.jpg",
    price: '11.00',
    name: 'Light Refresher',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.2'
  },
  {
    id: "dk4",
    cover: "../images/drk-3.jpg",
    price: '14.00',
    name: 'Decorated Shaked Mojito',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.6'
  },
  {
    id: "dk5",
    cover: "../images/drk-2.jpg",
    price: '12.00',
    name: 'Srinjjed Cocktail',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.3'
  },
  {
    id: "dk6",
    cover: "../images/drk-1.jpg",
    price: '11.50',
    name: 'Negroni Heavy Flass',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.7'
  },
  {
    id: "dk7",
    cover: "../images/drk-7.jpg",
    price: '11.50',
    name: 'Nagaronavola Hepricha',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.2'
  },
  {
    id: "dk8",
    cover: "../images/drk-9.jpg",
    price: '11.50',
    name: 'Veronavicjte Talisker',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.5'
  },
  {
    id: "dk9",
    cover: "../images/drk-8.jpg",
    price: '11.50',
    name: 'Tequila Overloaded',
    about: 'Lettuce, Eggs, Milk, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4'
  }
]



export const newsChef = [
  {
    cover: "../images/az-2.jpg",
    date: "May. 03, 2022",
    titleName: "Why do we go for you?",
    about: "Lorwm onahd ashhj onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj  hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj  shdhcjhsjhshs sjc  shsdhkjdsh ksdhckjhckjs hKSHi hshd jhshdkh kjadkjhd oashoidh kdsk ahdhasj jlisuds"

  },
  
  {
    cover: "../images/az-3.jpg",
    date: "Aug. 13, 2021",
    titleName: "Why do we go for you?",
    about: "Lorwm onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj  onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj hjkdkusdh hksdhs j hdckjsh hsdkchchiudH hdasabjcabka Bbksaa ahkjhs ya jlksjd  ashkdsk ahdhasj jlisuds"

  },
  {
    cover: "../images/az-1.jpg",
    date: "Sep. 03, 2020",
    titleName: "Why do we go for you?",
    about: "Lorwm onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj  onahd jhdkjhkas hadhksj kahkdjhhd'las ashkjdh  ksdhdc kj hjkdkusdh hksdhs j hdckjsh hsdkchchiudH hdasabjcabka Bbksaa ahkjhs ya jlksjd  ashkdsk ahdhasj jlisuds"

  }
]

export const testimonials = [
  {
    feedback: "Its goood better twhw oppo kuiraut dhdh dlkd dj  in the  hcjsg hjsdusah bdghdg remial bhcdja goood better twhw oppo kuirautg udgusj  goood better twhw oppo kuiraut dgksdnext plot is b",
    clientName: "Oberie Makern"
  },
  {
    feedback: "Its goood better twhw oppo kuiraut goood better twhw oppo oram mollaj kuiraut in the  hcjsg hjsdusah goood better twhw oppo kuiraut bdghdg bhcdjag udgusj dgksdnext plot is b",
    clientName: "Abdus Salam Noor"
  },
  {
    feedback: "Its goood better twhw oppo kuiraut hjkdshkjhsd  ingoood better twhw oppo kuiraut the  hcjsg hjsdusah bdghdg goood better twhw oppo kuiraut bhcdjag udgusj dgksdnext plot is b",
    clientName: "Zerakan Uryn"
  },
  {
    feedback: "Its goood better twhw oppo kuiraut ingoood better twhw oppo kuiraut  nooram batir the  hcjsg hjsdusah bdghdg bhcdjag udgusj dgksdnext plot is b",
    clientName: "Tipu Sultan"
  }
]

export const galleryImg = [
  {
    cover: "../images/az-1.jpg",
  },
  {
    cover: "../images/cat-8.jpg",
  },
  {
    cover: "../images/az-5.jpg",
  },
  {
    cover: "../images/az-7.jpg",
  },
  {
    cover: "../images/az-2.jpg",
  },
  {
    cover: "../images/az-6.jpg",
  }
]

export const ourLocation = [
  {
    contactIcon: 'fa-solid fa-phone-flip',
    contactType: 'Phone',
    contactDetails: '+91 (763) 2393 7889',
    contactDetails2: ''
  },
  {
    contactIcon: 'fa-solid fa-location-dot',
    contactType: 'Address',
    contactDetails: '11/8 Moti Nagar, Orantola, Jokihat',
    contactDetails2: ''
  },
  {
    contactIcon: 'fa-solid fa-clock',
    contactType: 'Working Hours',
    contactDetails: 'Mon - Fri: 10:00 - 22:00',
    contactDetails2: 'Sat - Sun: 12:00 - 00:00'
  }
]

export const Clocks = [

    { label: "10:00", value: 35 },
    { label: "11:00", value: 54 },
    { label: "12:00", value: 43 },
    { label: "13:00", value: 61 },
    { label: "14:00", value: 96 },
    { label: "15:00", value: 46 },
    { label: "16:00", value: 50 },
    { label: "17:00", value: 52 },
    { label: "18:00", value: 58 },
    { label: "19:00", value: 45 },
    { label: "20:00", value: 81 },
    { label: "21:00", value: 38 },
    { label: "22:00", value: 56 },
    { label: "23:00", value: 13 },
    { label: "00:00", value: 41 }
   

]

export const Guests = [

  { label: "1 Person", value: 35 },
  { label: "2 Persons", value: 54 },
  { label: "3 Persons", value: 43 },
  { label: "4 Persons", value: 61 },
  { label: "5 Persons", value: 96 },
  { label: "6 Persons", value: 46 },
  { label: "7 Persons", value: 41 },
]


export const specialOccDish1 = [

  {
    id: "osp1",
    cover: "../images/spcl-1.jpg",
    price: '13.50',
    name: 'Minted Fish',
    about: 'Mint, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.8'
  },
  {
    id: "osp2",
    cover: "../images/spcl-2.jpg",
    price: '14.50',
    name: 'Apple Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.4'
  },
  {
    id: "osp3",
    cover: "../images/spcl-3.jpg",
    price: '15.50',
    name: 'Cheese Pamezzon',
    about: 'Milk, Lettuce, Eggs, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.7'
  },
  {
    id: "osp4",
    cover: "../images/spcl-4.jpg",
    price: '12.00',
    name: 'Minted Fish',
    about: 'Mint, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.5'
  },
  {
    id: "osp5",
    cover: "../images/spcl-5.jpg",
    price: '16.50',
    name: 'Apple Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.7'
  },
  {
    id: "osp6",
    cover: "../images/spcl-6.jpg",
    price: '18.50',
    name: 'Cheese Pamezzon',
    about: 'Milk, Lettuce, Eggs, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.3'
  }
]

export const specialOccDish2 = [

  {
    id: "ospp1",
    cover: "../images/spcll-1.jpg",
    price: '13.00',
    name: 'Minted Fish',
    about: 'Mint, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.6'
  },
  {
    id: "ospp2",
    cover: "../images/spcll-2.jpg",
    price: '11.50',
    name: 'Apple Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.7'
  },
  {
    id: "ospp3",
    cover: "../images/spcll-3.jpg",
    price: '8.50',
    name: 'Cheese Pamezzon',
    about: 'Milk, Lettuce, Eggs, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.7'
  },
  {
    id: "ospp4",
    cover: "../images/spcll-4.jpg",
    price: '13.00',
    name: 'Minted Fish',
    about: 'Mint, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.4'
  },
  {
    id: "ospp5",
    cover: "../images/spcll-5.jpg",
    price: '11.50',
    name: 'Veriyted Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.5'
  },
  {
    id: "ospp6",
    cover: "../images/spcll-6.jpg",
    price: '8.50',
    name: 'Cheese Pamezzon',
    about: 'Milk, Lettuce, Eggs, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.8'
  }
]

export const specialOccDish3 = [

  {
    id: "osppp1",
    cover: "../images/spclll-1.jpg",
    price: '13.00',
    name: 'Minted Fish',
    about: 'Mint, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.3'
  },
  {
    id: "osppp2",
    cover: "../images/spclll-2.jpg",
    price: '11.50',
    name: 'Apple Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.4'
  },
  {
    id: "osppp3",
    cover: "../images/spclll-3.jpg",
    price: '8.50',
    name: 'Cheese Pamezzon',
    about: 'Milk, Lettuce, Eggs, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.2'
  },
  {
    id: "osppp4",
    cover: "../images/spclll-4.jpg",
    price: '13.00',
    name: 'Minted Fish',
    about: 'Mint, Vanilla Ice Cream, Cashew Nuts, Berries, Cream Bell.',
    stars: '4.7'
  },
  {
    id: "osppp5",
    cover: "../images/spclll-5.jpg",
    price: '13.50',
    name: 'Veriyted Cake',
    about:'Cherries, Dough, White Sugar, Nuts, Vanilla Ice Cream, Carried.',
    stars: '4.6'
  },
  {
    id: "osppp6",
    cover: "../images/spclll-6.jpg",
    price: '12.50',
    name: 'Cheese Pamezzon',
    about: 'Milk, Lettuce, Eggs, Parmesan Cheese, Chicken Breast Fillets.',
    stars: '4.5'
  }
]